// invoiceParsers.js
import React from "react";
import NumberFormat from "react-number-format";
import moment from "moment";
import "./Invoices.css";
import "moment/locale/pt-br";

moment.locale("pt-br");

export const formatCurrencyFromCents = (valueInCents = 0) => {
  const value = parseFloat(valueInCents || 0) / 100;
  return (
    <NumberFormat
      value={value}
      displayType="text"
      thousandSeparator="."
      prefix="R$"
      decimalScale={2}
      fixedDecimalScale
      decimalSeparator=","
    />
  );
};

export const formatCurrency = (value = 0) => (
  <NumberFormat
    value={parseFloat(value || 0)}
    displayType="text"
    thousandSeparator="."
    prefix="R$"
    decimalScale={2}
    fixedDecimalScale
    decimalSeparator=","
  />
);

export const calculateProductsTotal = (order) => {
  if (!order || !order.products || !order.products.length) return 0;
  return order.products.reduce((total, item) => {
    const unitPrice = item.ProductSale
      ? item.ProductSalePrice
      : item.ProductPrice;
    return total + item.ProductQuantity * unitPrice;
  }, 0);
};

export const formatDateTime = (date) =>
  date ? moment(date).format("DD/MM/YYYY HH:mm") : "";

export const formatDate = (date) =>
  date ? moment(date).format("DD/MM/YYYY") : "";
